import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cookie-consent"
// Displays the cookie notice banner until the visitor accepts it.
const STORAGE_KEY = "cookieConsentAccepted"

export default class extends Controller {
  connect() {
    if (localStorage.getItem(STORAGE_KEY)) {
      this.hide()
    } else {
      this.show()
    }
  }

  accept() {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString())
    this.hide()
  }

  show() {
    this.element.classList.remove("hidden")
  }

  hide() {
    this.element.classList.add("hidden")
  }
}
